import cn from 'clsx'
import { FC } from 'react'

import CancelGray from '@/assets/icons/cancel-gray.svg'

import Button from '../button/Button'
import Typography from '../typography/Typography'

interface IMovingStripesProps {
	bgColor: string
	text: string
	className?: string
	buttonClassName?: string
	handleStopTranscription?: () => void
	hideCancelButton?: boolean
}

const MovingStripes: FC<IMovingStripesProps> = ({
	bgColor,
	text,
	className,
	buttonClassName,
	handleStopTranscription,
	hideCancelButton
}) => {
	return (
		<div
			className={cn(
				'flex items-center justify-between',
				'px-4 rounded-[16px]',
				`bg-${bgColor}`,
				hideCancelButton ? 'py-[31px]' : 'py-[22px]',

				// stripes
				'bg-[repeating-linear-gradient(135deg,rgba(255,255,255,0.6)_0px,rgba(255,255,255,0.6)_25px,rgba(255,255,255,0)_25px,rgba(255,255,255,0)_75px)]',

				// pattern size
				'bg-[length:106px_106px]',

				// move animation
				'animate-moving-stripes',
				className
			)}
		>
			<Typography
				variant='text'
				className='text-[16px] !font-[500] !leading-[140%]'
			>
				{text || ''}
			</Typography>

			{/* Backend cannot interrupt translation process. So the button is hidden during translation*/}
			{!hideCancelButton && (
				<Button
					className={cn(buttonClassName)}
					onClick={handleStopTranscription}
				>
					<CancelGray />
				</Button>
			)}
		</div>
	)
}

export default MovingStripes
